import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import helper components
import ScrollToTop from './Components/ScrollToTop';

// Import layout components
import Header from './Components/Header';
import Footer from './Components/Footer';

// Import page components
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import PackageList from './pages/PackageList';
import PackageDetails from './pages/PackageDetails';
import MyMenu from './pages/MyMenu';
import CategoryMeals from './pages/CategoryMeals';
import SubscriptionReview from './pages/SubscriptionReview'; 
import ProfilePage from './pages/ProfilePage';
import DeliveryStatusPage from './pages/DeliveryStatusPage';
import QRScanPage from './pages/QRScanPage';
import UpdateStatusPage from './pages/UpdateStatusPage';
import UserDashboard from './pages/UserDashboard';
import AddOnsPage from './pages/AddOnsPage';
import PartyOrders from './pages/PartyOrders'; 
import TermsAndConditions from './Components/TermsAndConditions'; // ✅ YOUR EXISTING IMPORT

// Import admin/utility components
import AddPackages from './Components/AddPackages';
import AddMeals from './Components/AddMeals';
import AddCategories from './Components/AddCategories';
import BackfillMenuImages from './Components/BackfillMenuImages';

// Import context
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Header />
          <main>
            <Routes>
              {/* Main public routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/addons" element={<AddOnsPage />} />
              <Route path="/package" element={<PackageList />} />
              <Route path="/package/:packageId" element={<PackageDetails />} />
              <Route path="/category/:categoryId/meals" element={<CategoryMeals />} />
              <Route path="/category/:categoryId/review" element={<SubscriptionReview />} />
              <Route path="/party-orders" element={<PartyOrders />} /> 
              
              {/* ✅ ADD THE NEW ROUTE FOR TERMS AND CONDITIONS */}
              <Route path="/TermsAndConditions" element={<TermsAndConditions />} />

              {/* User-specific routes */}
              <Route path="/my-menu" element={<MyMenu />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/delivery-status" element={<DeliveryStatusPage />} />
              <Route path="/user/scan-qr" element={<QRScanPage />} />
              <Route path="/user/update-status/:orderId" element={<UpdateStatusPage />} />
              <Route path="/user-dashboard/*" element={<UserDashboard />} />

              {/* Admin/utility routes */}
              <Route path="/add-packages" element={<AddPackages />} />
              <Route path="/add-meals" element={<AddMeals />} />
              <Route path="/add-categories" element={<AddCategories />} />
              <Route path="/backfill-images" element={<BackfillMenuImages />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;